<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de local de coleta">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/jornada/List'

export default {
    components: { List },
}
</script>